/*
Copyright (c) 2025 Mathilde Meyer, Naziha Beghdadi
Licensed under the MIT License (see LICENSE.txt file for details)
*/

import React from "react";
import { Box, Pagination, PaginationItem, Button, Typography } from "@mui/material";
export default function IntroductionPagination({ step, setStep, total, submit, localStep }) {
  const handleChange = (event, value) => {
    setStep(value);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={3}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, fontSize: "0.78rem", textAlign: "center" }}
      >
        Experiment number (you may add/delete a new experiment at any time; click on the experiment number to navigate between experiments)
      </Typography>
      <Pagination
        count={total}
        page={step}
        onChange={handleChange}
        color="primary"
        size="medium"
        renderItem={(item) => (
          <PaginationItem
            {...item}
            disableRipple
            sx={{
              '&:hover': {
                transform: 'none',
                boxShadow: 'none',
                backgroundColor: item.selected ? 'primary.main' : 'transparent',
              },
              '&:active': {
                transform: 'none',
                backgroundColor: item.selected ? 'primary.main' : 'transparent',
              },
            }}
          />
        )}
      />
      {step === total && localStep === 2 && (
        <Box mt={2}>
          <Button variant="contained" onClick={submit}>
            Preview &amp; Generate Document
          </Button>
        </Box>
      )}
    </Box>
  );
}
